export const calculateOpacity = (index: number) => {
  const opacity = 500 + 100 * index;

  return opacity > 900 ? 900 : opacity;
};
